import { makeStyles } from '@material-ui/styles';

import { neutral } from 'shared/styles/colors';

export default makeStyles({
  root: {
    marginBottom: '-0.25rem',
    minHeight: 'auto',
    fontFamily: 'Poppins',
    fontSize: '0.75rem',
    fontStretch: 'normal',
    fontStyle: 'normal',
    fontWeight: 'normal',
    letterSpacing: 'normal',
    lineHeight: 'normal',
    textTransform: 'none',
    color: neutral['70'],
  },
});
